module.exports = __webpack_public_path__ + "images/ExternalPromo/weebly-378912-300_250.gif?82f64";